


































































import Vue, { PropType } from "vue";
import InfiniteLoading from "vue-infinite-loading";
import { Data, Methods, Computed, Props } from "./types";
import Radio from "@/components/Atoms/Forms/Radio/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import LayoutColumnDouble from "@/components/Atoms/Layout/ColumnDouble/index.vue";
import Notification from "./Molecules/Notification/index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "Notifications",
  components: {
    Radio,
    Heading,
    LayoutColumnDouble,
    Notification,
    InfiniteLoading
  },
  props: {
    notifications: {
      type: Array as PropType<Props["notifications"]>,
      required: true
    },
    queryParams: {
      type: Object as PropType<Props["queryParams"]>,
      required: true
    }
  },
  data() {
    return {
      categoryOptions: [
        { value: "all", label: "すべて" },
        { value: "experience", label: "新着体験談・クチコミ" },
        { value: "partner_notification_new", label: "新着応募" },
        { value: "partner_notification_change", label: "キャンセル・日程変更" },
        { value: "partner_notification_confirm", label: "求人の承認・却下通知" }
      ]
    };
  },
  computed: {
    // NOTE StoreからqueryParamsに該当するNotificationsを取得する
    lastFetchNotifications() {
      return this.$store.getters[
        "domains/notifications/getNotificationsByQuery"
      ](this.queryParams);
    }
  },
  methods: {
    async infiniteHandler($state: any) {
      // NOTE queryParamsが更新されるのを待って処理する
      this.$nextTick(async () => {
        await this.$store.dispatch(
          "domains/notifications/getNotifications",
          this.queryParams
        );
        const lastFetchNotifications = await this.$store.getters[
          "domains/notifications/getNotificationsByQuery"
        ](this.queryParams);
        if (lastFetchNotifications.length > 0) {
          const { offset, limit } = this.queryParams;
          // NOTE 裏で通知が増えた場合等にoffset, limitが同じ値でもレスポンス結果が異なり、Id重複を起こす。
          // その結果、storeのlengthがlimitの値に比例して増えていかないため、
          // 「limit」ではなく、「レスポンス実態のlength分」だけoffsetをずらす。
          const newParams = {
            ...this.queryParams,
            offset: offset + lastFetchNotifications.length,
            limit
          };
          this.$emit("updateQueryParams", newParams);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    handleReadNotification(notificationId) {
      this.$emit("readNotification", notificationId);
    },
    handleCategoryChange(category) {
      this.$emit("updateQueryParams", { offset: 0, limit: 10, category });
      this.$emit("resetNotifications");
      this.infiniteClear();
    },
    infiniteClear() {
      const infiniteLoading = this.$refs.infiniteLoading as
        | InfiniteLoading
        | undefined;
      infiniteLoading?.stateChanger.reset();
    }
  }
});
